/**
 * Authentication Guard
 * Protects routes that require authentication
 * Uses Angular Signals for reactive state
 */

import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { RouteBuilder, QUERY_PARAMS } from '../constants/routes.constants';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  // Store the attempted URL for redirecting after login
  sessionStorage.setItem('auth_redirect_after_login', state.url);

  // Redirect to offers page (users can use login modal)
  router.navigate([RouteBuilder.offers()]);
  return false;
};
